import { Component, OnInit } from '@angular/core';
import { RestService } from '../rest.service';

@Component({
  selector: 'app-calllog',
  templateUrl: './calllog.component.html',
  styleUrls: ['./calllog.component.scss']
})
export class CalllogComponent implements OnInit {

  records: any = [];
  options: any[] = [];
  valor;
  constructor(
    private rest: RestService
  ) {
    this.GetData();
    this.Categories();
  }

  ngOnInit() {
    setInterval(function () { this.GetData(); }.bind(this), 30000);
  }

  GetData() {
    this.rest.GetView()
    .subscribe(
      (data) => {
        this.records = data['data'];
      });
  }

  Categories() {
    this.rest.GetCategories().subscribe( (data) => {
      this.options = data['data'];
    });
  }

  Categorize(contact) {
    this.rest.PostCategorize(contact.id, contact.category_id)
    .subscribe( () => {});
  }

}
